import React from 'react';

import { FormattedMessage } from 'react-intl/dist';

export default function SupplementalCoverage({ link, exchangeName }: { link: string, exchangeName: string }) {
    return (
        <>
            <div className="grid-row">
                <h4 id="supplemental_coverage_header">
                    <FormattedMessage
                        id="supplemental_coverage.header"
                        data-automation-id="supplemental_coverage_header"
                    />
                </h4>
            </div>
            <div className="padding-2">
                <FormattedMessage
                    id="supplemental_coverage.description"
                    values={{ exchangeName }}
                    data-automation-id="supplemental_coverage_description"
                />{' '}
                <br />
                <a href={link} target="_blank">
                    <FormattedMessage
                        id="supplemental_coverage.click_here"
                        data-automation-id="supplemental_coverage_link"
                    />
                </a>{' '}
                <FormattedMessage id="supplemental_coverage.cta" />
            </div>
        </>
    );
}
